import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import React from "react";
import logo from "./../logo.png"; // Replace this with your actual logo path

const Frame: React.FC<{ children: any }> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col items-center">
      {/* Cog Icon */}
      <div className="absolute top-0 right-4">
        <a
          href="/apps/d4fe7ad0-0784-4fdf-b8b1-063758be6d48"
          className="p-2 rounded-full"
          title="Settings"
        >
          <Cog6ToothIcon className="h-8 w-8 text-gray-700" />
        </a>
      </div>
      {/* Logo Section */}
      <header className="my-16">
        <a href="/">
          <img src={logo} className="h-24 mx-auto" alt="logo" />
        </a>
      </header>

      {/* Grid Section */}
      {children}
    </div>
  );
};

export default Frame;
